import BaseElement from './BaseElement'
import { ValidateFormCustom } from '../components/ValidateFormCustom'

export default class ValidateFormCustomElement extends BaseElement {
  renderElement () {
    this.rootElement.render(<ValidateFormCustom children={this} />)
  }
}
